<template>
    <div class="person">
        <!-- <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div> -->
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                :default-expand-all="false"
                style="width: 100%">
                
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="userId" label="用户ID" align="center" width="160">
                </el-table-column>
                <el-table-column prop="nickName" label="用户昵称" align="center" width="160">
                </el-table-column>
                <!-- <el-table-column prop="phone" label="用户手机" align="center">
                </el-table-column> -->
                <el-table-column prop="header" label="用户头像" align="center" width="100">
                    <template slot-scope="scope">
                        <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.header"
                        :preview-src-list="[scope.row.header]"
                        v-if="scope.row.header"
                        fit="cover"></el-image>
                    </template>
                </el-table-column>
                
                <el-table-column prop="description" label="反馈内容" align="center"></el-table-column>
                <el-table-column prop="creationTime" label="创建时间" align="center" width="160"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="detailShow(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="查询详情" width="750px">
            <!-- <forms ref="formListDetail" :list="formList" :value="formData" :rules="formRules" :btns="formDetailBtns" labelWidth="120px"></forms> -->
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户ID
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.userId" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用户昵称
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.nickName" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用户头像
                    </div>
                    <div class="value">
                        <el-image
                        style="width: 80px; height: 80px"
                        :src="detailData.header"
                        :preview-src-list="[detailData.header]"
                        v-if="detailData.header"
                        fit="cover"></el-image>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        用户手机
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.phone" size="small" placeholder=""></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        反馈内容
                    </div>
                    <div class="value">
                        <el-input v-model="detailData.description" size="small" placeholder="" type="textarea"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        图片
                    </div>
                    <div class="value">
                        <div class="picList">
                            <div class="pic" v-for="(item,index) in detailData.pathList" :key="index">
                                <el-image
                                style="width: 80px; height: 80px"
                                :src="item"
                                :preview-src-list="[item]"
                                fit="cover"

                                ></el-image>
                                <!-- <img class="pic-edit" src="../../../assets/images/icon08.png" alt="" @click="clearEditPath(index)"> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        
        </el-dialog>
        
        
        
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {parseTimeS} from '../../../utils/index'
  

export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,
            isDetailDialog:false,
            formData:{},
            formDataAdd:{
                "parentId": "",
                "name": "",
                "sort": 0,
                "imgUrl": "",
                "isShow": true,
            },
            totalCount:0,
            // tableData:[],
            tableData: [
                
            ],

            conditionData:{
                sendPhone: "",
                toPhone: "",
                sendCity: "",
                toCity: "",
                pageSize: 10,
                page: 1
            },
            queryList:[
                {type: "input",label: "发送者手机号:",name: "sendPhone"},
                {type: "input",label: "接收者手机号:",name: "toPhone"},
                {type: "input",label: "发送者城市:",name: "sendCity"},
                {type: "input",label: "接收者城市:",name: "toCity"}
            ],
            detailData:{}
           
            
           
        }
    },
    created(){
    },
    mounted(){
        this.loadingData();
    },
    methods:{
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            let res  = await api.QueryFeedback(this.conditionData);
            console.log('loadingData');
            console.log(res.data);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
            // for(let index = 0;index<tableData.length;index++){
            //     tableData[index].creatTimeStr = parseTimeS(tableData[index].creatTime)
                
            // }
            console.log(this.tableData);
        },
        // 查询
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                sendPhone: "",
                toPhone: "",
                sendCity: "",
                toCity: "",
                pageSize: 10,
                page: 1 
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(pageSize){
            this.conditionData.page = 1;
            this.conditionData.pageSize = pageSize;
            this.loadingData();
        },
        showAddDialog(){
            this.isAddDialog = true;
        },
        async detailShow(row){
            this.isDetailDialog = true;
            this.detailData = row;
        },
        
    }
    
}
</script>

<style lang="scss" scoped>
    .person{
        height: 700px;
    }
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        padding-top: 30px;
        font-size: 14px;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .picList{
        display: flex;
        flex-wrap: wrap;
        margin:0 10px;
        .pic{
            position: relative;
            margin: 5px;
            width: 100px;
            height: 100px;
            .pic-edit{
                position: absolute;
                z-index: 10;
                top: -10px;
                right: -10px;
                width: 22px;
                height: 22px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                i{
                    color: #ffffff;
                }
                .error{
                    color: #f56c6c;
                }
                .success{
                    color: #a9ffa9;
                }
            }
        }
    }
</style>
